<div class="possible-tax-info">
  <h4>{{ "tw_possible_taxable_heading" | translate }}</h4>
  <p>{{ "tw_possible_taxable_detail" | translate }}</p>
  @if (showLink) {
    <a class="link" [href]="link" target="_blank"> {{ "details_tx_item" | translate }}</a>
  }
</div>
